import React from 'react';
import { MARQUEE_ITEMS } from '../mock';
import { Sparkles } from 'lucide-react';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative border-y border-purple-900/40 bg-gradient-to-r from-purple-950/20 via-black/40 to-pink-950/20 py-4 overflow-hidden">
      <div className="marquee">
        {items.map((it, i) => (
          <span key={i} className="inline-flex items-center gap-2 text-sm text-gray-300">
            <Sparkles className="w-3.5 h-3.5 text-pink-400" /> {it}
            <span className="text-purple-500">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
